import { jsx as _jsx } from "react/jsx-runtime";
import { useRecordShellEnabled } from '../../components/RecordShell/recordShellFlag';
import { CaptureListPage } from './CaptureListPage';
import { PursuitsListPage } from './PursuitsListPage';
/** GRW-14: `/capture` is the Pursuits list with growth_record_shell_v1 on, else today's page. */ export function PursuitsListRoute() {
    return useRecordShellEnabled() ? /*#__PURE__*/ _jsx(PursuitsListPage, {}) : /*#__PURE__*/ _jsx(CaptureListPage, {});
}
